import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  Paper,
  Typography,
} from "@material-ui/core";
import TierIcon from "./TierIcon";

import { withStyles, makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "hidden",
    display: "none",
  },
  container: {
    maxHeight: window.innerHeight - 350,
    color: "#828282",
    boxShadow: "0px 5px 5px #ebebeb",
  },

  footerFullScreenCell: {
    fontSize: 20,
    fontWeight: "bolder",

    backgroundColor: "white",
  },
  ColorText: {
    color: "#828282",
  },
  TextTableBody: {
    textAlign: "left",
  },
  TableHeader: { boxShadow: "0px 5px 5px #ebebeb" },
}));
const StyledTableRow = withStyles((i) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: i.palette.action.hover,
    },
  },
}))(TableRow);

const TableforPrint = React.forwardRef((props, ref) => {
  // const { fullScreen = false } = props;
  const [footer, setFooter] = useState([]);
  const classes = useStyles();
  const { pageTitle } = props;
  if (!props.data || props.data.list.length === 0) {
    return (
      <>
        <Typography
          style={{ margin: "0 auto", position: "relative", top: 0, bottom: 0 }}
          variant="h4"
          align="center"
        ></Typography>
      </>
    );
  }

  return (
    <Paper className={classes.root}>
      <TableContainer className={classes.container} component={Paper}>
        <Table ref={ref} aria-label="Print table">
          <TableHead className={classes.TableHeader}>
            <TableRow>
              <TableCell>
                {" "}
                <Typography variant="h2" noWrap>
                  {pageTitle}
                </Typography>
              </TableCell>
            </TableRow>
            <TableRow>
              {Object.entries(props.data.list[0]).map(([key, _], index) => {
                return (
                  <TableCell
                    className={classes.ColorText}
                    ref={(cell) => {
                      if (cell !== null && footer.length <= index)
                        setFooter((headers) => [...headers, cell.offsetWidth]);
                    }}
                    key={index}
                    align="left"
                  >
                    <Typography noWrap>{key}</Typography>
                  </TableCell>
                );
              })}
            </TableRow>
          </TableHead>

          <TableBody ref={ref}>
            {props.data.list.map((row, index) => (
              <StyledTableRow key={index}>
                {Object.entries(row).map(([key, val], index2) => (
                  <React.Fragment key={index2}>
                    {key === "Tier" ? (
                      <TableCell>
                        <TierIcon level={val} />
                      </TableCell>
                    ) : (
                      <TableCell
                        dangerouslySetInnerHTML={{ __html: val }}
                        align="left"
                        className={classes.ColorText}
                      />
                    )}
                  </React.Fragment>
                ))}
              </StyledTableRow>
            ))}
          </TableBody>
          <TableFooter>
            {Object.entries(props.data.summarytier[0]).map(
              ([_, val], index) => (
                <TableCell key={index} className={classes.footerFullScreenCell}>
                  {val}
                </TableCell>
              )
            )}
          </TableFooter>
        </Table>
      </TableContainer>
    </Paper>
  );
});

export default TableforPrint;
